varying vec2 vUv;
uniform float curveStrength;
uniform float velocity;
uniform float spiralRadius;
uniform float spiralAngle;
uniform float heightLoop;
uniform float transitionProgress;
uniform float focused;

const float PI = 3.1415926535897932384626433832795;

void main() {
    vUv = uv;
    vec3 pos = position;
    
    if (focused < 0.5) {
        // Calcul de l'intensité de la courbure basée sur la vitesse
        float intensity = abs(velocity * 200.0) * curveStrength;
        float curve = intensity * pow(abs(pos.y), 2.0) * sign(velocity);
        
        // Calculer une courbure cylindrique uniforme qui diminue avec la transition
        float angle = (pos.x / 2.5) * curveStrength;
        float radius = 2.5 / curveStrength;
        
        // Transformer la position x en position circulaire
        pos.x = sin(angle) * radius;
        pos.z = (1.0 - cos(angle)) * radius;
        
        // Ajouter l'effet de courbure basé sur Y
        pos.x += curve;
        
        // Ajouter l'effet de la vitesse
        pos.x += velocity * 100.0 * curveStrength;

        // Ajouter l'effet de parallélogramme horizontal basé sur la vitesse
        pos.x += pos.y * velocity * 25.0;
    }

    gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);
}
